import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-container">
          {/* Column 1: Brand & Tagline */}
          <div className="footer-col footer-brand">
            <h3 className="footer-logo-title">
              Youth L.I.F.E. <span className="brand-accent">Support Network</span>
            </h3>
            <p className="footer-tagline">
              A 501(c)(3) community-based non-profit dedicated to public safety, violence prevention, youth advocacy, and family reintegration across the Capital Region.
            </p>
            <div className="social-links">
              <a 
                href="https://www.facebook.com/people/Youth-Life-Support-Network-Inc/61559826671354/" 
                target="_blank" 
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <i className="fa-brands fa-facebook-f"></i>
              </a>
              <a 
                href="https://www.instagram.com/youthlifesupportnetwork" 
                target="_blank" 
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <i className="fa-brands fa-instagram"></i>
              </a>
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div className="footer-col">
            <h4 className="footer-heading">Quick Navigation</h4>
            <ul className="footer-links">
              <li><Link to="/"><i className="fa-solid fa-chevron-right"></i> Home</Link></li>
              <li><Link to="/about"><i className="fa-solid fa-chevron-right"></i> About Us</Link></li>
              <li><Link to="/programs"><i className="fa-solid fa-chevron-right"></i> Our Programs</Link></li>
              <li><Link to="/events"><i className="fa-solid fa-chevron-right"></i> Community Events</Link></li>
            </ul>
          </div>

          {/* Column 3: Our Initiatives */}
          <div className="footer-col">
            <h4 className="footer-heading">Our Core Programs</h4>
            <ul className="footer-links">
              <li><Link to="/programs#program-1"><i className="fa-solid fa-chevron-right"></i> Back2LIFE Support</Link></li>
              <li><Link to="/programs#program-2"><i className="fa-solid fa-chevron-right"></i> 1Life2Live Prevention</Link></li>
              <li><Link to="/programs#program-3"><i className="fa-solid fa-chevron-right"></i> L.E.A.D. Diversion</Link></li>
            </ul>
          </div>

          {/* Column 4: Contact & Hub Locations */}
          <div className="footer-col">
            <h4 className="footer-heading">Regional Locations</h4>
            <div className="footer-location-item">
              <i className="fa-solid fa-location-dot location-icon"></i>
              <div>
                <strong>Albany Hub:</strong>
                <p>313 Hamilton Street, Albany, NY 12210</p>
                <a href="tel:5185990714" className="footer-phone"><i className="fa-solid fa-phone"></i> (518) 599-0714</a>
              </div>
            </div>
            <div className="footer-location-item">
              <i className="fa-solid fa-location-dot location-icon"></i>
              <div>
                <strong>Schenectady Hub:</strong>
                <p>120 Emmons Street, Schenectady, NY 12305</p>
                <a href="tel:5182807584" className="footer-phone"><i className="fa-solid fa-phone"></i> (518) 280-7584</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Copyright Strip */}
      <div className="footer-bottom">
        <div className="footer-bottom-container">
          <span>&copy; {new Date().getFullYear()} Youth L.I.F.E. Support Network, Inc. &bull; 501(c)(3) Non-Profit Organization</span>
          <span className="footer-bottom-rights">All Rights Reserved</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;